export function canViewProductCost() {
  try {
    const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
    const allowed =
      permissions?.cadastros?.novoProduto?.permissoesEspecificas
        ?.visualizarValorCusto;

    // Permissões anteriores à criação desta opção mantêm o acesso atual.
    return allowed !== false;
  } catch (_) {
    return false;
  }
}
